<template>
    <!--
            作者：luoyiming
            时间：2019-10-25
            描述：门店-门店管理
        -->
    <div class="user clearfix">

        <!--添加门店-->
        <div class="common-level-rail fl">
            <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/supplier/supplier/add'"
                v-if="is_chain == 1">{{ $t('添加门店') }}
            </el-button>
        </div>
        <div class="common-seach-wrap fr" v-auth="'/auth/shop'">
            <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="">
                    <el-input v-model="formInline.search" :placeholder="$t('请输入门店名称')"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="onSubmit">{{ $t('查询') }}</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!--内容-->
        <div class="product-content">
            <div class="table-wrap">
                <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
                    <el-table-column prop="shop_supplier_id" :label="$t('门店ID')" width="90"></el-table-column>
                    <el-table-column prop="name" :label="$t('门店名称')">
                        <template slot-scope="scope">
                            <span>{{ scope.row.name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="superUser.user_name" :label="$t('登录账号')"></el-table-column>
                    <el-table-column prop="link_name" :label="$t('联系人')" width="90"></el-table-column>
                    <el-table-column prop="link_phone" :label="$t('联系电话')" width="120"></el-table-column>
                    <el-table-column prop="address" :label="$t('联系地址')"></el-table-column>
                    <!--          <el-table-column prop="total_money" :label="$t('总金额')"></el-table-column>-->
                    <!--          <el-table-column prop="money" :label="$t('可用余额')"></el-table-column>-->
                    <!--          <el-table-column prop="cash_money" :label="$t('已提现')"></el-table-column>-->
                    <!--          <el-table-column prop="freeze_money" :label="$t('提现中')"></el-table-column>-->
                    <el-table-column prop="create_time" :label="$t('添加时间')" width="150"></el-table-column>
                    <el-table-column fixed="right" :label="$t('操作')" width="150">
                        <template slot-scope="scope">
                            <el-button @click="recycle(scope.row, 0)" type="text" size="small"
                                v-auth="'/supplier/supplier/recycle'" v-if="scope.row.is_recycle == 1">{{ $t('开启') }}
                            </el-button>
                            <el-button @click="recycle(scope.row, 1)" type="text" size="small"
                                v-auth="'/supplier/supplier/recycle'" v-else>{{ $t('禁止') }}
                            </el-button>
                            <el-button @click="editClick(scope.row)" type="text" size="small"
                                v-auth="'/supplier/supplier/edit'">{{ $t('编辑') }}
                            </el-button>
                            <el-button @click="qrcode(scope.row)" type="text" size="small"
                                v-auth="'/supplier/supplier/qrcode'">{{ $t('二维码') }}
                            </el-button>
                            <el-button @click="settingClick(scope.row)" type="text" size="small"
                                v-auth="'/supplier/supplier/setting'">{{ $t('设置') }}
                            </el-button>
                            <el-button v-if="scope.row.is_main == 0" @click="deleteClick(scope.row.shop_supplier_id)"
                                type="text" size="small" v-auth="'/supplier/supplier/delete'">{{ $t('删除') }}
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!--分页-->
            <div class="pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                    :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
                    :total="totalDataNumber">
                </el-pagination>
            </div>
        </div>
        <Qrcode :open='isqrcode' :code_id='code_id' @close="closeQrcode"></Qrcode>
    </div>
</template>

<script>
import SupplierApi from '@/api/supplier.js';
import Qrcode from './dialog/Qrcode.vue';

export default {
    components: {
        Qrcode
    },
    data() {
        return {
            /*是否加载完成*/
            loading: true,
            /*列表数据*/
            tableData: [],
            /*门店列表数据*/
            storeList: [],
            /*一页多少条*/
            pageSize: 20,
            /*一共多少条数据*/
            totalDataNumber: 0,
            /*当前是第几页*/
            curPage: 1,
            /*横向表单数据模型*/
            formInline: {
                shop_id: '',
                search: ''
            },
            /*是否打开添加弹窗*/
            open_add: false,
            /*是否打开编辑弹窗*/
            open_edit: false,
            /*当前编辑的对象*/
            userModel: {},
            isqrcode: false,
            code_id: '',
            is_chain: '',
        };
    },
    methods: {
        /*选择第几页*/
        handleCurrentChange(val) {
            let self = this;
            self.curPage = val;
            self.loading = true;
            self.getTableList();
        },

        /*每页多少条*/
        handleSizeChange(val) {
            this.curPage = 1;
            this.pageSize = val;
            this.getTableList();
        },

        /*获取列表*/
        async getTableList() {
            let self = this;
            let Params = {};
            Params.page = self.curPage;
            Params.list_rows = self.pageSize;
            let res = await SupplierApi.supplierList(Params, true)
            if (res && res.code === 1) {
                self.loading = false;
                self.tableData = res.data.list.data;
                self.totalDataNumber = res.data.list.total;
                self.is_chain = res.data.is_chain;
            } else {
                self.loading = false;
            }

        },

        /*搜索查询*/
        onSubmit() {
            this.curPage = 1;
            this.getTableList();
        },

        /*打开添加*/
        addClick() {
            this.$router.push('/supplier/supplier/add');
        },
        qrcode(row) {
            let self = this;
            self.code_id = row.shop_supplier_id;
            self.isqrcode = true;
        },
        closeQrcode() {
            let self = this;
            self.isqrcode = false;
        },
        /*打开编辑*/
        editClick(row) {
            let self = this;
            let params = row.shop_supplier_id;
            this.$router.push({
                path: '/supplier/supplier/edit',
                query: {
                    shop_supplier_id: params
                }
            })
        },
        /*打开编辑*/
        settingClick(row) {
            let self = this;
            let params = row.shop_supplier_id;
            this.$router.push({
                path: '/supplier/supplier/setting',
                query: {
                    shop_supplier_id: params
                }
            })
        },
        /* 强制下架上架*/
        recycle(row, state) {
            let self = this;
            let war = "";
            if (state == 1) {
                war = self.$t("禁止")
            } else if (state == 0) {
                war = self.$t("开启")
            }
            self
                .$confirm(self.$t("确认要") + war, self.$t('提示'), {
                    type: 'warning'
                })
                .then(() => {
                    SupplierApi.supplierRecycle({
                        shop_supplier_id: row.shop_supplier_id,
                        is_recycle: state
                    }).then(data => {
                        self.$message({
                            message: war + self.$t('成功') ,
                            type: 'success'
                        });
                        self.getTableList();
                    });
                });
        },
        /*删除*/
        deleteClick(row) {
            let self = this;
            self.$confirm(self.$t('此操作将永久删除该记录, 是否继续?'), self.$t('提示'), {
                confirmButtonText: self.$t('确定'),
                cancelButtonText: self.$t('取消'),
                type: 'warning'
            }).then(() => {
                self.loading = true;
                SupplierApi.deleteSupplier({
                    shop_supplier_id: row
                }, true)
                    .then(data => {
                        self.loading = false;
                        if (data.code == 1) {
                            self.$message({
                                message: self.$t('恭喜你，门店删除成功'),
                                type: 'success'
                            });
                            self.getTableList();
                        }
                    })
                    .catch(error => {
                        self.loading = false;
                    });
            }).catch(() => {
                self.loading = false;
            });
        }
    },
    async mounted() {
        /*获取列表*/
        await this.getTableList();
        let currentStore = localStorage.getItem('currentStore')
        console.log(this.tableData)
        if (currentStore && Number(currentStore)) {
            return
        } else {
            let id = this.tableData[0].shop_supplier_id
        }
    },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/index.vue